import { useEffect } from 'react';
import { useFormikContext } from 'formik';

import minimizeTitleContext from './MinimizeTitleContext';

type Props<TValues> = {
  getTitle: (values: TValues) => string | null | undefined;
};

// Rendered inside a modal's Formik form; reports a value derived from the live
// form values as the modal's dock-pill title. No-op outside a minimizable
// modal (no context value), so it is safe to drop into shared forms.
const FormMinimizeTitle = <TValues,>({ getTitle }: Props<TValues>) => {
  const report = minimizeTitleContext.useContextOptional();
  const { values } = useFormikContext<TValues>();

  const title = getTitle(values);

  useEffect(() => {
    report?.(title ?? '');
  }, [report, title]);

  return null;
};

export default FormMinimizeTitle;
